import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { DashboardService } from '../../dashboard.service';
import { MatButtonToggleChange } from '@angular/material/button-toggle';
import {
    FormBuilder,
    FormControl,
    FormGroup,
    Validators,
} from '@angular/forms';
import { AngularEditorConfig } from '@kolkov/angular-editor';
import { initializeEditor } from 'src/app/utils/editorConfig';
import { helper } from 'src/environments/helper';
import { CommonService } from 'src/app/services/common.service';
import { NotificationService } from 'src/app/services/notification.service';
import { PermissionsService } from 'src/app/services/permissions.service';
import { finalize, map } from 'rxjs';
import { Generic } from 'src/app/interfaces/generic.interface';
import { DocumentData, EditRequestPriorityPayload, EditRequestStatusPayload } from '../../document.interface';
import Swal from 'sweetalert2';


@Component({
    selector: 'app-actiuni-document',
    templateUrl: './actiuni-document.component.html',
    styleUrls: ['./actiuni-document.component.scss']
})
export class ActiuniDocumentComponent implements OnInit {
    @Input() data!: DocumentData;
    @Output() docChanged: EventEmitter<void> = new EventEmitter();

    errorTitle: string = helper.dialogConfig.headers.errorAtentie;
    errorIcon: string = helper.dialogConfig.icons.error;
    errorType: string = helper.dialogConfig.icons.error;
    helper = helper;

    successTitle: string = helper.dialogConfig.headers.success;
    successIcon: string = helper.dialogConfig.icons.success;
    successType: string = helper.dialogConfig.icons.success;

    isLoading: boolean = false;

    selectedActionToggle = 'status';
    sendUpdateStatusForm!: FormGroup;
    sendUpdatePriorityForm!: FormGroup;
    editorConfig!: AngularEditorConfig;

    requestStatuses: Generic[] = [];
    requestPriorities: Generic[] = [];

    defaultChoiceParameter: { name: string; id: number } = {
        name: '-- Alegeți --',
        id: -1,
    };

    constructor(
        private fb: FormBuilder,
        public dashboardService: DashboardService,
        private commonService: CommonService,
        private notificationService: NotificationService,
        public permissionsService: PermissionsService
    ) { }

    ngOnInit(): void {
        this.editorConfig = initializeEditor();

        this.loadRequestStatuses();
        this.loadRequestPriorities();

        this.sendUpdateStatusForm = this.fb.group({
            current_status: new FormControl(-1, [Validators.required, Validators.min(0)]),
            message: new FormControl(''),
        });
        this.sendUpdatePriorityForm = this.fb.group({
            id_priority: new FormControl(-1, [Validators.required, Validators.min(0)]),
            message: new FormControl(''),
        });
    }

    loadRequestStatuses() {
        this.commonService
            .getStatusesActive()
            .pipe(map((results: any) => [this.defaultChoiceParameter, ...results]))
            .subscribe((data) => {
                this.requestStatuses = data;
            });
    }

    loadRequestPriorities() {
        this.commonService
            .getPrioritiesActive()
            .pipe(map((results: any) => [this.defaultChoiceParameter, ...results]))
            .subscribe((data) => {
                this.requestPriorities = data;
            });
    }

    onActionChange(event: MatButtonToggleChange) {
        this.selectedActionToggle = event.value;
    }

    submitUpdateStatusMessage() {
        this.isLoading = true;

        const { current_status, message } = this.sendUpdateStatusForm.value;

        const newRequestStatus: EditRequestStatusPayload = {
            current_status,
            message
        };

        this.dashboardService
            .updateStatus(this.data.id_document, newRequestStatus)
            .pipe(finalize(() => (this.isLoading = false)))
            .subscribe({
                next: (res) => {
                    this.isLoading = true;

                    Swal.fire({
                        title: this.successTitle,
                        text: 'Status actualizat cu succes!',
                        icon: 'success',
                        showCancelButton: false,
                        showConfirmButton: true,
                        confirmButtonText: helper.dialogConfig.buttonLabels.close,
                        allowOutsideClick: false,
                    }).then((result) => {
                        if (result.isConfirmed) {
                            const current_status = this.sendUpdateStatusForm.controls['current_status'];
                            const message = this.sendUpdateStatusForm.controls['message'];
                            this.docChanged.emit();

                            current_status.patchValue(-1);
                            current_status.clearValidators();
                            current_status.setErrors(null);
                            current_status.markAsUntouched();
                            message.patchValue('');
                        }
                    });
                },
                error: (err) => {
                    let msg;
                    try {
                        msg = err.error.errors.message[0];
                    } catch (error) {
                        msg = helper.dialogConfig.generalMessages.error;
                    }
                    this.notificationService.warningSwal(
                        this.errorTitle,
                        msg,
                        this.errorIcon
                    );
                },
            });
    }

    submitUpdatePriorityMessage() {
        this.isLoading = true;

        const { id_priority, message } = this.sendUpdatePriorityForm.value;

        const newRequestPriority: EditRequestPriorityPayload = {
            id_priority,
            message
        };

        this.dashboardService
            .updatePriority(this.data.id_document, newRequestPriority)
            .pipe(finalize(() => (this.isLoading = false)))
            .subscribe({
                next: (res) => {
                    this.isLoading = true;

                    Swal.fire({
                        title: this.successTitle,
                        text: 'Prioritate actualizată cu succes!',
                        icon: 'success',
                        showCancelButton: false,
                        showConfirmButton: true,
                        confirmButtonText: helper.dialogConfig.buttonLabels.close,
                        allowOutsideClick: false,
                    }).then((result) => {
                        if (result.isConfirmed) {
                            const id_priority = this.sendUpdatePriorityForm.controls['id_priority'];
                            const message = this.sendUpdatePriorityForm.controls['message'];
                            this.docChanged.emit();

                            id_priority.patchValue(-1);
                            id_priority.clearValidators();
                            id_priority.setErrors(null);
                            id_priority.markAsUntouched();
                            message.patchValue('');
                        }
                    });
                },
                error: (err) => {
                    let msg;
                    try {
                        msg = err.error.errors.message[0];
                    } catch (error) {
                        msg = helper.dialogConfig.generalMessages.error;
                    }
                    this.notificationService.warningSwal(
                        this.errorTitle,
                        msg,
                        this.errorIcon
                    );
                },
            });
    }
}
